import { Timer } from "./svg";
import { Fragment } from "react";
import { Bogo, BuyItAll, Offers } from "./lib";
import { useWebStoreContext } from "contexts";
import { useMediaQuery } from "@mui/material";
import CountdownV2 from "components/CountdownV2";
import DebugCopyIdButton from "debug/components/DebugCopyIdButton";
import { useAppDispatch } from "hooks";
import { getLimitedDeals, onSetStickyDIPData } from "redux/slices";
import { Container, BgBrush, Image } from "./styles";
import bgBrush from "assets/limited-deals/bg-brush.png";
import bgBrushMobile from "assets/limited-deals/bg-brush-mobile.png";
import classNames from "classnames";
import { IShopPurchaseOffer } from "contexts/WebStoreProvider/types";
import { CountdownOffer } from "./lib/CountdownOffer";
import CountdownV3 from "components/CountdownV3";
import {
	timerStyle,
	timerStyleMobile
} from "pages/StoreFront/lib/LimitedDealsSection/styles";
import { getVariantImage } from "helpers/getVariantImage";
import { DIPS_IMAGE_VARIANT_TAG } from "components/DIP/helper";

type Data = Omit<
	IShopPurchaseOffer,
	"onlyNonPayers" | "priority" | "purchaseButtonBannerText" | "bannerText"
>;
interface StickyDIPProps {
	data?: Data[];
}

const StickyDIP: React.FC<StickyDIPProps> = ({ data }: StickyDIPProps) => {
	const dispatch = useAppDispatch();
	const { nowTime } = useWebStoreContext();

	const isLowWidth = useMediaQuery("(max-width:733px)");
	const isMobile = isLowWidth;

	const endTime = data?.[0].timerExpirationDate as string;
	const showCountDown = nowTime?.isBefore(endTime);
	const isBogo =
		data?.[0]?.dip?.isBogo || data?.[0]?.dip?.templateType === "Bogo";
	const isBuyItAll =
		data?.[0]?.dip?.isBuyItAll || data?.[0]?.dip?.templateType === "BuyItAll";
	const isCountdownOffer = data?.[0]?.dip?.templateType === "Countdown";
	const className = classNames({
		"buy-it-all": isBuyItAll
	});

	return data && showCountDown ? (
		<Fragment>
			<Container className={`${className} animate__animated`}>
				<Image
					className={className}
					src={getVariantImage(
						data?.[0]?.dip?.imageUrl as string,
						DIPS_IMAGE_VARIANT_TAG,
						isMobile ? "small" : "large"
					)}
				/>
				<BgBrush src={isMobile ? bgBrushMobile : bgBrush} />
				{!isCountdownOffer && (
					<CountdownV2
						icon={<Timer />}
						endTime={endTime}
						style={{
							...(isMobile ? timerStyleMobile : timerStyle),
							...(isBuyItAll && !isMobile ? { top: "7%" } : {})
						}}
						startTime={nowTime}
						text="Offer ends in: "
						labelStyle={{ color: "#EB5757", marginLeft: 6 }}
						onEnd={() => {
							dispatch(onSetStickyDIPData(data[0]));
							dispatch(getLimitedDeals());
						}}
					/>
				)}
				{isCountdownOffer && (
					<CountdownV3
						// @ts-ignore
						endTime={endTime}
						startTime={nowTime}
						text={"Offer ends in:"}
						className="dip-countdown"
						onEnd={() => {
							dispatch(onSetStickyDIPData(data[0]));
							dispatch(getLimitedDeals());
						}}
						//hideTimerDisplayOnEnd={true}
						style={{
							position: "absolute",
							bottom: isMobile ? "unset" : "15%",
							left: isMobile ? "50%" : "4.6%",
							transform: isMobile ? "translateX(-50%)" : "unset",
							top: isMobile ? "28%" : "unset",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							flexDirection: "column",
							gap: "0.5rem",
							fontSize: isMobile
								? "clamp(10px, 14.4dvw, 110px)"
								: "clamp(52px, 7dvw, 90px)"
						}}
						labelStyle={{
							WebkitTextStrokeWidth: "0.22em",
							WebkitTextStrokeColor: "#000",
							paintOrder: "stroke fill",
							color: "#fff",
							fontWeight: 400,
							fontSize: "0.35em",
							fontFamily: "Baloo",
							lineHeight: "1.2em"
						}}
					/>
				)}
				<DebugCopyIdButton
					id={data?.[0]?.dip?.id as string}
					label="OfferID"
					side="left"
					vertical="bottom"
					style={{ fontSize: "1.3em", zIndex: 4 }}
				/>
				{isBogo ? (
					<Bogo data={data} />
				) : isBuyItAll ? (
					<BuyItAll data={data} />
				) : isCountdownOffer ? (
					<CountdownOffer data={data} />
				) : (
					<Offers data={data} />
				)}
			</Container>
		</Fragment>
	) : null;
};

export default StickyDIP;
